import clsx from 'clsx';

interface SkeletonProps {
  className?: string;
  rounded?: 'none' | 'sm' | 'md' | 'lg' | 'full';
}

const ROUNDED: Record<NonNullable<SkeletonProps['rounded']>, string> = {
  none: '',
  sm: 'rounded',
  md: 'rounded-md',
  lg: 'rounded-lg',
  full: 'rounded-full',
};

export function Skeleton({ className, rounded = 'md' }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={clsx(
        'block bg-canvas bg-shimmer-line bg-shimmer animate-shimmer',
        ROUNDED[rounded],
        className,
      )}
    />
  );
}

export function SkeletonCard() {
  return (
    <div
      className="card p-4 flex items-center gap-3"
      aria-busy="true"
      aria-label="Loading"
    >
      <Skeleton rounded="full" className="h-11 w-11 shrink-0" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-3 w-1/2" />
      </div>
    </div>
  );
}
